module.exports = __webpack_public_path__ + "img/carousel2.959aed25.jpg";